<template>
    <v-layout column>
        <v-flex>
            <div class="text-xs-left">
                <v-btn
                        flat
                        @click="goBack"
                >
                    <v-icon left small>fal fa-chevron-left</v-icon>
                    {{ $vuetify.t('$vuetify.back') }}
                </v-btn>
            </div>
        </v-flex>
        <v-flex v-if="order" xs12>
            <!--            <h2 class="primary&#45;&#45;text" v-if="order.document_identifier">{{ order.document_identifier }}</h2>-->
            <!--            <h2 class="primary&#45;&#45;text" v-else>{{ order.ref_doc_number }}</h2>-->
            <v-list>
                <v-list-tile v-if="order.date">
                    <v-list-tile-avatar>
                        <v-icon color="primary">fal fa-calendar</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ order.created_date }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>


                <v-list-tile v-if="order.store">
                    <v-list-tile-avatar>
                        <v-icon color="primary">fal fa-map-marker-alt</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ order.store }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile v-if="order.status">
                    <v-list-tile-avatar>
                        <OrdersStatus
                                :statusCode="order.status_code"></OrdersStatus>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            <span class="grey--text" v-if="order.status_code === 2">{{ order.status }}&nbsp;({{ order.status_date }})</span>
                            <span class="blue--text" v-else-if="order.status_code === 4 || order.status_code === 5">{{ order.status }}&nbsp;({{ order.status_date }})</span>
                            <span class="green--text" v-else-if="order.status_code === 7">{{ order.status }}&nbsp;({{ order.status_date }})</span>
                            <span class="error--text" v-else-if="order.status_code === 8">{{ order.status }}&nbsp;({{ order.status_date }})</span>
                            <span class="amber--text" v-else>{{ order.status }}&nbsp;({{ order.status_date }})</span>
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="order.shipping_method">
                    <v-list-tile-avatar style="border-radius: 0">
                        <OrdersShipment
                                :shipmentCode=order.shipping_method_code></OrdersShipment>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title @click="goToStoreDetail(order.shipping_store_id)">
                            <span v-if="order.shipping_store">{{ order.shipping_store }}</span>
                            <span v-else-if="order.shipping_tracking_code">{{ order.shipping_tracking_code }}</span>
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>

            <v-spacer class="my-3"></v-spacer>

            <v-expansion-panel :value="itemsPanel">
                <v-expansion-panel-content :readonly="false" :hide-actions="false"
                                           style="background:transparent">
                    <template v-slot:header>
                        <h2 class="primary--text">{{ $vuetify.t('$vuetify.items') }}</h2>
                    </template>
                    <ItemsList
                            :items="order.details"
                            :displayEditQuantity=false
                            :displayRemove=false></ItemsList>

                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-divider v-if="order.total" class="my-3 grey lighten-2"></v-divider>

            <v-flex offset-sm4 offset-md6 offset-lg8>
                <v-list>
                    <v-list-tile v-if="order.total">
                        <v-list-tile-content>
                            <v-list-tile-title><h2>{{ $vuetify.t('$vuetify.total') }}</h2></v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <h2>{{ order.total }}&nbsp;{{ order.currency }}</h2>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-flex>
        </v-flex>
        <v-btn  v-if="!orderHasOnlyMenu"
                fixed
                dark
                fab
                bottom
                right
                color="primary">
            <v-icon @click="addOrdersItemsToCart()">fal fa-shopping-cart</v-icon>
        </v-btn>
    </v-layout>
</template>

<script>
    import {ordersService} from '@/_services';
    import {getErrorMessage} from '@/_helpers';
    import ItemsList from '@/components/ItemsList.vue';
    import OrdersStatus from '@/components/shop/OrdersStatus.vue';
    import OrdersShipment from '@/components/shop/OrdersShipment.vue';

    export default {
        name: "OrdersDetail",
        components: {ItemsList, OrdersStatus, OrdersShipment},
        data() {
            return {
                order: [],
                itemsPanel: 0,
                orderHasOnlyMenu: true,
            }
        },
        methods: {
            goBack() {
                this.$router.push({name: "orders"});
            },
            addOrdersItemsToCart() {
                var listItemsId = [];
                for (var i = 0; i < this.order.details.length; i++) {
                    if (Object.entries(this.order.details[i].menuItems).length === 0) {
                        listItemsId.push(this.order.details[i].item_id)
                    }
                }
                this.$store.dispatch("shop/addListOfItemsToCart", listItemsId);
            },
            /**
             * The method assigned to the button which is displayed once the Shopping Cart is empty. This button
             * redirects the user to the Catalog
             **/
            goToStoreDetail: function (pk) {
                this.$router.push({name: 'stores-detail', params: {id: pk}})
            },
        },
        mounted() {
            let id = parseInt(this.$route.params.id);
            this.$store.dispatch("loader/setLoading", true);

            ordersService.get(id).then(result => {
                    this.order = result;
                    this.$store.dispatch("loader/setLoading", false);

                    for (var i = 0; i < this.order.details.length; i++) {
                        if (Object.entries(this.order.details[i].menuItems).length === 0) {
                            this.orderHasOnlyMenu = false;
                            break;
                        }
                    }
                    //The change of the toolbar title has to be managed inside the promise where the Order Detail is obtained
                    // After setting the meta, it is necessary to force the router to reload.
                    // Which is achieved by changing the query parameter
                    this.$route.meta.toolbarTitle = this.order.ref_doc_number;
                    // Add a temporary query parameter.
                    this.$router.replace({query: {temp: Date.now()}});
                    // Remove the temporary query parameter.
                    this.$router.replace({query: {temp: undefined}});

                },
                error => {
                    getErrorMessage(error, 'Getting the Order Detail', this);
                }
            );
        }
    }
</script>

<style scoped>

</style>
